import React, { useEffect } from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMCaseComplianceRaisesPanel } from "../../components/Complex/CRMCaseComplianceRaisesPanel/CRMCaseComplianceRaisesPanel";

const CRMCaseComplianceRaisesContainer = (props: TContainerStateProps): JSX.Element => {
    const canManageComplianceReports = props.state.global.user.can_manage_compliance_reports;

    useEffect(
        () => {
            if (canManageComplianceReports) {
                props.dispatch({
                    type: "CASE_COMPLIANCE_RAISES_VIEW",
                    payload: null,
                });
            }
        },
        [canManageComplianceReports]
    );

    if (!canManageComplianceReports) {
        return <></>;
    }

    return (
        <CRMCaseComplianceRaisesPanel
            form={props.state.forms.case_compliance_raises_page}
            onChange={(payload) => props.dispatch({
                type: "CASE_COMPLIANCE_RAISES_UPDATE_FORM",
                payload
            })}
            onUpdateNote={(payload) => props.dispatch({
                type: "CASE_COMPLIANCE_RAISES_UPDATE_NOTE",
                payload
            })}
            onRevoke={(payload) => props.dispatch({
                type: "CASE_COMPLIANCE_RAISES_REVOKE",
                payload
            })}
        />
    );
};

export default CRMCaseComplianceRaisesContainer;
